<template>
<el-tabs type="border-card">
  <el-tab-pane label="Category">
    <Category />
  </el-tab-pane>
  <el-tab-pane label="Entry">
    <Entry />
  </el-tab-pane>
</el-tabs> 
</template>

<script>
import Category from '../components/faq/Category'
import Entry from '../components/faq/Entry'



export default {
  components: {
    Category,
    Entry
  }
}
</script>
